var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 23,
    height: 23,
    rx: 4,
    fill: "#8800C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1391 11.5004C14.1391 12.7719 13.1046 13.8064 11.833 13.8064C10.5615 13.8064 9.52702 12.7719 9.52702 11.5004C9.52702 10.2288 10.5615 9.19436 11.833 9.19436C13.1046 9.19436 14.1391 10.2288 14.1391 11.5004ZM11.833 3.83372C7.60543 3.83372 4.16638 7.27277 4.16638 11.5004C4.16638 15.728 7.60543 19.167 11.833 19.167C13.3817 19.167 14.8751 18.7059 16.1516 17.8336L16.1735 17.8182L15.1407 16.6179L15.1231 16.6288C14.1407 17.2613 13.0028 17.5954 11.833 17.5954C8.47231 17.5954 5.73805 14.8611 5.73805 11.5004C5.73805 8.13965 8.47231 5.40539 11.833 5.40539C15.1938 5.40539 17.928 8.13965 17.928 11.5004C17.928 11.9357 17.8793 12.3766 17.7846 12.8103C17.5918 13.6016 17.0376 13.8436 16.622 13.8119C16.2036 13.7779 15.714 13.48 15.7107 12.7506V12.1948V11.5004C15.7107 9.36193 13.9715 7.62269 11.833 7.62269C9.6946 7.62269 7.95536 9.36193 7.95536 11.5004C7.95536 13.6388 9.6946 15.3781 11.833 15.3781C12.8719 15.3781 13.8461 14.9723 14.5805 14.2335C15.0076 14.8983 15.7036 15.3151 16.496 15.3786C16.5639 15.3841 16.6335 15.3868 16.7019 15.3868C17.26 15.3868 17.8125 15.2001 18.2583 14.8622C18.7177 14.5128 19.0611 14.0085 19.2505 13.4023C19.2807 13.3042 19.3365 13.0803 19.3365 13.0786L19.3382 13.0704C19.4499 12.5841 19.4997 12.0995 19.4997 11.5004C19.4997 7.27277 16.0607 3.83372 11.833 3.83372Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.b76aedc7.svg";
export { ForwardRef as ReactComponent };